export var GET_DIST_POST_QUERY_DATA = "GET_DIST_POST_QUERY_DATA";
export var GET_DIST_POST_QUERY_DATA_SUCCESS = "GET_DIST_POST_QUERY_DATA_SUCCESS";
export var GET_DIST_POST_QUERY_DATA_FAILED = "GET_DIST_POST_QUERY_DATA_FAILED";